import React, { useCallback, useState, useRef } from "react";
import { useDropzone } from "react-dropzone";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Grid,
  CircularProgress
} from "@material-ui/core";
import useStyles from "@/styles/dialogStyle";
import { useTranslation } from "@/langs/useTranslation";
import styles from "./index.module.less";
import { IconWindows, IconClose } from "@/components/Icon";
import { s3upload } from "@/helpers/s3upload";

import { androidAppUploadCheck } from "@/apis/apiCollection";
import { toast } from "@/apis/request";
import UploadImage from "@/components/UploadImage";
import ApplicationProgramApi from "@/apis/applicationProgramApi";

const UploadWindowsAppDialog = ({
  open,
  onClose,
  updateAppInfo,
  setRefreshCapacity,
  reloadTable,
  onSuccess
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const restAppInfo = {
    icon: "",
    iconFile: "",
    name: "",
    package_name: "",
    package_id: "",
    fileName: "",
    package: "",
    version: "",
    versionCode: "",
    file: null,
    extend: ""
  };

  const [appInfo, setAppInfo] = useState(restAppInfo);
  // 发起上传
  const [uploading, setUploading] = useState(false);
  const [errors, setErrors] = useState({
    package_name: false,
    package_id: false,
    version: false
  });
  const [percentCompleted, setPercentCompleted] = useState(0);
  const uploadRef = useRef(null);

  const onDrop = useCallback(
    async acceptedFiles => {
      if (acceptedFiles.length === 0) {
        toast.error(t({ defaultMessage: "不支持的格式。" }));
        return;
      }
      setUploading(true);
      const fileName = acceptedFiles[0].name;
      window.test = acceptedFiles[0]
      console.log(acceptedFiles[0], 'checkout')
      if (acceptedFiles[0].name.endsWith(".bat")) {
        setUploading(false);
        setAppInfo({
          ...appInfo,
          name: fileName,
          fileName: fileName,
          file: acceptedFiles[0],
          iconFile: appInfo.iconFile,
          package_id: "",
          version: appInfo.version,
          versionCode: "",
          extend: appInfo.extend,
          icon: updateAppInfo?.icon || appInfo.icon
        });
        return
      }
      if (acceptedFiles[0].type === "application/zip") {
        const JSZip = await import("jszip");
        const zip = await JSZip.default.loadAsync(acceptedFiles[0]);
        // 标志位：是否包含 .bat 文件
        let hasBatFile = false;
        // 标志位：.bat 文件命名是否正确
        let isBatFileNameValid = true;

        // 遍历 ZIP 文件中的每个文件
        Object.keys(zip.files).forEach(relativePath => {
          // 检查文件扩展名是否为 .bat
          if (relativePath.indexOf("__MACOSX") >= 0) return;
          if (relativePath.endsWith(".bat")) {
            hasBatFile = true;

            // 检查文件名是否为 install.bat 或 uninstall.bat
            const fileName = relativePath.split("/").pop(); // 获取文件名
            if (fileName !== "install.bat" && fileName !== "uninstall.bat") {
              isBatFileNameValid = false;
            }
          }
        });
        setUploading(false);
        if (!hasBatFile || (hasBatFile && isBatFileNameValid)) {
          setAppInfo({
            ...appInfo,
            name: fileName,
            fileName: fileName,
            file: acceptedFiles[0],
            iconFile: appInfo.iconFile,
            package_id: "",
            version: appInfo.version,
            versionCode: "",
            extend: appInfo.extend,
            icon: updateAppInfo?.icon || appInfo.icon
          });
          return;
        } else {
          toast.error(
            t({ defaultMessage: "bat文件没有命名为install或者uninstall" })
          );
          return;
        }
      }
      try {
        const res = await ApplicationProgramApi.getWindowsInfo({
          file: acceptedFiles[0]
        });
        if (!res || !res.version) {
          toast.error(t({ defaultMessage: "该应用程序无法解析。" }));
          setAppInfo({
            ...appInfo,
            name: fileName,
            package_name: updateAppInfo?.package_name || appInfo.package_name,
            fileName: fileName,
            file: acceptedFiles[0],
            iconFile: appInfo.iconFile,
            package_id: "",
            version: appInfo.version,
            versionCode: "",
            extend: appInfo.extend,
            icon: updateAppInfo?.icon || appInfo.icon
          });
          setUploading(false);
          return;
        }
        setAppInfo({
          ...appInfo,
          name: fileName,
          package_name:
            res.version.package_name && res.version.package_name.length > 0
              ? res.version.package_name
              : updateAppInfo?.package_name || appInfo.package_name,
          fileName: fileName,
          file: acceptedFiles[0],
          iconFile: appInfo.iconFile,
          package_id: res.version.package_id,
          version: res.version.version,
          versionCode: res.version.version_code,
          extend: appInfo.extend,
          icon: updateAppInfo?.icon || appInfo.icon
        });
        setUploading(false);
      } catch (e) {
        // toast.error(t({ defaultMessage: '上传失败，该应用程序无法解析。' }));
        toast.error(t({ defaultMessage: "该应用程序无法解析。" }));
        setAppInfo({
          ...appInfo,
          name: fileName,
          package_name: updateAppInfo?.package_name || appInfo.package_name,
          fileName: fileName,
          file: acceptedFiles[0],
          iconFile: appInfo.iconFile,
          package_id: "",
          version: appInfo.version,
          versionCode: "",
          extend: appInfo.extend,
          icon: updateAppInfo?.icon || appInfo.icon
        });
        setUploading(false);
      }
    },
    [appInfo, updateAppInfo, t]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    noDrag: uploading,
    noClick: uploading,
    accept: {
      "application/octet-stream": [".exe", ".msi"],
      "application/zip": [".zip"],
      "application/x-bat": [".bat"],
    }
  });

  const wrongPackage =
    updateAppInfo &&
    appInfo.package &&
    updateAppInfo.package !== appInfo.package;
  const checkCanUpload = async () => {
    // 是修改的话
    if (updateAppInfo && Object.keys(updateAppInfo).length > 0) {
      appInfo.package_name = appInfo.package_name || updateAppInfo.package_name;
      appInfo.package_id = appInfo.package_id || updateAppInfo.package_id;
      appInfo.version = appInfo.version || updateAppInfo.version;
    }
    const newErrors = {
      package_name: !appInfo.package_name,
      package_id: !appInfo.package_id,
      version: !appInfo.version
    };
    setErrors(newErrors);
    if (Object.values(newErrors).some(Boolean) || wrongPackage) return false;
    // return true;

    try {
      const res = await androidAppUploadCheck({
        os_type: "windows",
        package_name: appInfo.package_name,
        package_id: appInfo.package_id,
        version_code: appInfo.versionCode,
        is_update:
          updateAppInfo && Object.keys(updateAppInfo).length > 0 ? true : false
      });
      return res.message === "success";
    } catch (e) {
      // if (e.response?.data?.errors?.commit_failed) {
      //   setTimeout(() => {
      //     toast.closeAll();
      //     toast.error(t({ defaultMessage: '版本代码已存在，请重新上传' }));
      //   });
      // }
      return false;
    }
  };

  const handleDeleteFile = useCallback(e => {
    e.stopPropagation();
    setAppInfo(restAppInfo);
  }, []);

  const onCloseDialog = useCallback(
    forceClose => {
      if (!forceClose && uploading) return;
      setAppInfo(restAppInfo);
      setUploading(false);
      setPercentCompleted(0);
      onClose();
    },
    [uploading, onClose]
  );

  const onOk = async () => {
    if (!appInfo.versionCode || appInfo.versionCode.length <= 0) {
      appInfo.versionCode = "0";
    }
    if (!(await checkCanUpload())) return;

    const reauestParam = {
      name: appInfo.name,
      package_name: appInfo.package_name,
      package_id: appInfo.package_id,
      version: appInfo.version,
      version_code: appInfo.versionCode,
      extend: appInfo.extend,
      iconFile: updateAppInfo ? null : appInfo.iconFile,
      icon: updateAppInfo?.icon || ""
    };
    setUploading(true);
    uploadRef.current = await s3upload(
      { files: [appInfo.file] },
      "",
      t,
      t({ defaultMessage: "上传Windows应用程序成功" }),
      percentCompleted,
      setPercentCompleted,
      () => onCloseDialog(true),
      setRefreshCapacity,
      reloadTable,
      true,
      false,
      false,
      true,
      false,
      false,
      undefined,
      "windows",
      reauestParam,
      onSuccess
    );
  };

  const handleChangeIcon = imageInfo => {
    setAppInfo({ ...appInfo, iconFile: imageInfo.file });
  };

  return (
    <Dialog
      maxWidth={false}
      className={classes.dialog}
      open={open}
      onClose={onCloseDialog}
      aria-labelledby="add-file"
      aria-describedby="add-file-confirmation"
      disableEscapeKeyDown={uploading}
    >
      <DialogTitle id="add-file" style={{ paddingTop: "12px !important" }}>
        {updateAppInfo
          ? t({ defaultMessage: "更新Windows应用程序" })
          : t({ defaultMessage: "上传Windows应用程序" })}
      </DialogTitle>
      <DialogContent
        className="uploadFileOnlyDialog"
        style={{ width: 560, paddingBottom: "0px !important" }}
      >
        {updateAppInfo ? (
          <div>
            <Typography variant="subtitle1" style={{ marginTop: 24 }}>
              {t({ defaultMessage: "当前程序信息" })}
            </Typography>
            <div className={styles.currentAppInfo}>
              <Box
                component="label"
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Grid item xs={2}>
                  <Typography>{t({ defaultMessage: "程序名称：" })}</Typography>
                </Grid>
                <Grid item xs={10}>
                  <Typography variant="subtitle1">
                    {updateAppInfo.package_name}
                  </Typography>
                </Grid>
              </Box>
              <Box
                component="label"
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Grid item xs={2}>
                  <Typography>{t({ defaultMessage: "版本号：" })}</Typography>
                </Grid>
                <Grid item xs={10}>
                  <Typography variant="subtitle1">
                    {updateAppInfo.version}
                  </Typography>
                </Grid>
              </Box>
              <Box
                component="label"
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Grid item xs={2}>
                  <Typography>{t({ defaultMessage: "进程名称：" })}</Typography>
                </Grid>
                <Grid item xs={10}>
                  <Typography variant="subtitle1">
                    {updateAppInfo.package_id}
                  </Typography>
                </Grid>
              </Box>
            </div>
            <Box
              component="label"
              sx={{ display: "flex", alignItems: "center", marginTop: 24 }}
            >
              <Typography variant="subtitle1">
                {t({ defaultMessage: "版本号：" })}
              </Typography>
              <Typography variant="body1" color="error">
                *
              </Typography>
            </Box>
            <TextField
              placeholder={t({ defaultMessage: "请输入版本号" })}
              fullWidth
              value={appInfo.version}
              onChange={e => {
                const value = e.target.value;
                const nonChineseRegex = /^[^\u4e00-\u9fa5]*$/; // 非中文正则表达式
                if (nonChineseRegex.test(value)) {
                  setAppInfo({ ...appInfo, version: value });
                }
              }}
              disabled={uploading}
              variant="outlined"
              size="small"
              style={{ marginTop: 8 }}
            />
            {errors.version && (
              <Typography color="error">
                {t({ defaultMessage: "版本号必填" })}
              </Typography>
            )}

            <Box
              component="label"
              sx={{ display: "flex", alignItems: "center", marginTop: 24 }}
            >
              <Typography variant="subtitle1">
                {t({ defaultMessage: "输入指令以部署文件：" })}
              </Typography>
            </Box>
            <TextField
              placeholder={t({ defaultMessage: "请输入指令" })}
              fullWidth
              value={appInfo.extend}
              onChange={e => setAppInfo({ ...appInfo, extend: e.target.value })}
              disabled={uploading}
              variant="outlined"
              size="small"
              style={{ marginTop: 8 }}
            />
          </div>
        ) : (
          <>
            <Box
              component="label"
              sx={{ display: "flex", alignItems: "center", marginTop: 24 }}
            >
              <Typography variant="subtitle1">
                {t({ defaultMessage: "上传App icon：" })}
              </Typography>
            </Box>
            <UploadImage onChange={handleChangeIcon} disabled={uploading} />
            <Box
              component="label"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Typography variant="subtitle1">
                {t({ defaultMessage: "程序名称：" })}
              </Typography>
              <Typography variant="body1" color="error">
                *
              </Typography>
            </Box>
            <TextField
              placeholder={t({ defaultMessage: "请输入程序名称" })}
              fullWidth
              value={appInfo.package_name}
              onChange={e => {
                const value = e.target.value;
                if (value.length <= 30) {
                  setAppInfo({ ...appInfo, package_name: value });
                }
              }}
              disabled={uploading}
              variant="outlined"
              size="small"
              style={{ marginTop: 8 }}
              inputProps={{ maxLength: 30 }}
            />
            {errors.package_name && (
              <Typography color="error">
                {t({ defaultMessage: "程序名称必填" })}
              </Typography>
            )}

            <Box
              component="label"
              sx={{ display: "flex", alignItems: "center", marginTop: 24 }}
            >
              <Typography variant="subtitle1">
                {t({ defaultMessage: "进程名称：" })}
              </Typography>
              <Typography variant="body1" color="error">
                *
              </Typography>
            </Box>
            <TextField
              placeholder={t({ defaultMessage: "请输入进程名称" })}
              fullWidth
              value={appInfo.package_id}
              onChange={e => {
                const value = e.target.value;
                if (value.length <= 30) {
                  setAppInfo({ ...appInfo, package_id: value });
                }
              }}
              disabled={uploading}
              variant="outlined"
              size="small"
              style={{ marginTop: 8 }}
              inputProps={{ maxLength: 30 }}
            />
            {errors.package_id && (
              <Typography color="error">
                {t({ defaultMessage: "进程名称必填" })}
              </Typography>
            )}

            <Box
              component="label"
              sx={{ display: "flex", alignItems: "center", marginTop: 24 }}
            >
              <Typography variant="subtitle1">
                {t({ defaultMessage: "版本号：" })}
              </Typography>
              <Typography variant="body1" color="error">
                *
              </Typography>
            </Box>
            <TextField
              placeholder={t({ defaultMessage: "请输入版本号" })}
              fullWidth
              value={appInfo.version}
              onChange={e => {
                const value = e.target.value;
                const nonChineseRegex = /^[^\u4e00-\u9fa5]*$/; // 非中文正则表达式
                if (nonChineseRegex.test(value)) {
                  setAppInfo({ ...appInfo, version: value });
                }
              }}
              disabled={uploading}
              variant="outlined"
              size="small"
              style={{ marginTop: 8 }}
            />
            {errors.version && (
              <Typography color="error">
                {t({ defaultMessage: "版本号必填" })}
              </Typography>
            )}

            <Box
              component="label"
              sx={{ display: "flex", alignItems: "center", marginTop: 24 }}
            >
              <Typography variant="subtitle1">
                {t({ defaultMessage: "输入指令以部署文件：" })}
              </Typography>
            </Box>
            <TextField
              placeholder={t({ defaultMessage: "请输入指令" })}
              fullWidth
              value={appInfo.extend}
              onChange={e => setAppInfo({ ...appInfo, extend: e.target.value })}
              disabled={uploading}
              variant="outlined"
              size="small"
              style={{ marginTop: 8 }}
            />
          </>
        )}
        <Typography variant="subtitle1" style={{ marginTop: 24 }}>
          {t({ defaultMessage: "上传Windows应用程序" })}
        </Typography>
        <div
          className={`${styles.uploadArea} ${isDragActive ? styles.dragActive : ""
            } ${uploading ? styles.uploading : ""}`}
          {...getRootProps()}
        >
          <input {...getInputProps()} />
          <IconWindows size={58} color="#00AFC6" />
          {uploading ? (
            <Box display="flex" alignItems="center">
              <CircularProgress size={14} />
              <Typography style={{ marginLeft: 10, color: "#91919F" }}>
                {percentCompleted !== 0
                  ? t(
                    { defaultMessage: "正在上传 {percentCompleted}%" },
                    { percentCompleted }
                  )
                  : t({ defaultMessage: "解析中" })}
              </Typography>
            </Box>
          ) : (
            <>
              {appInfo.fileName ? (
                <div className={styles.uploadInfoBox}>
                  <div className={styles.uploadNameTip}>{appInfo.fileName}</div>
                  <div className={styles.closeBtn} onClick={handleDeleteFile}>
                    <IconClose size={10} color="rgb(245,74,68)" />
                  </div>
                </div>
              ) : (
                <>
                  <Typography className={styles.uploadTip}>
                    {t({ defaultMessage: "上传Windows应用程序" })}
                    <br />
                    {t({ defaultMessage: "(exe安装程序、msi文件、zip压缩包)" })}
                    <br />
                    {t({
                      defaultMessage:
                        "(请把压缩包中的bat文件命名为install或者uninstall)"
                    })}
                  </Typography>
                  <Typography className={styles.uploadTip2}>
                    {t({ defaultMessage: "将文件拖到此处 或点击上传" })}
                  </Typography>
                </>
              )}
            </>
          )}
        </div>
        {wrongPackage && (
          <Typography color="error">
            {t({ defaultMessage: "程序包ID不一致" })}
          </Typography>
        )}
        <Box display="flex" justifyContent="center" sx={{ marginTop: 32 }}>
          <Button
            variant="contained"
            color="primary"
            style={{ width: 150, height: 40 }}
            onClick={onOk}
            disabled={!appInfo.file || uploading}
          >
            {t({ defaultMessage: "确认" })}
          </Button>
          {uploading && percentCompleted != 0 ? (
            <Button
              color="secondary"
              variant="outlined"
              type="button"
              style={{ width: 150, height: 40, marginLeft: 10 }}
              onClick={() => {
                if (uploadRef.current) {
                  uploadRef.current.abort();
                }
                onCloseDialog(true);
              }}
            >
              {t({ defaultMessage: "取消上传" })}
            </Button>
          ) : (
            <Button
              variant="contained"
              style={{
                width: 150,
                height: 40,
                background: "rgba(0, 175, 198, 0.1)",
                color: uploading ? undefined : "#00afc6",
                marginLeft: 10
              }}
              onClick={onCloseDialog}
            >
              {t({ defaultMessage: "取消" })}
            </Button>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default UploadWindowsAppDialog;
